import Joi from 'joi';

export const ProjectSchema = Joi.object({
  name: Joi.string().required(),
  projectTypeId: Joi.number().required().min(1),
  provinceId: Joi.number().required(),
  fiscalYearId: Joi.number().required(),
});

// export const BudgetSchema = Joi.object({
//   recriveDate: Joi.date().required(),
//   budgetItems: Joi.array().items(Joi.object({
//     budgetTypeId: Joi.number().required(),
//     amount: Joi.number().required(),
//   })).min(1).required()
// });

export const ApprovementSchema = Joi.object({
  cabinetMinisterId: Joi.number().required(),
  approvedDate: Joi.date().required(),
});

export const AttachmentSchema = Joi.object({
  name: Joi.string().required(),
  file: Joi.string().required(),
});
